<template>
  <Dialog
    width="400px"
    customClass="confirm-cancel-dialog"
    :hideCloseBtn="true"
    :visible="visible"
    titleAlign="center"
    background="rgba(53, 53, 76,0.8)"
  >
    <div class="main">
      <div class="title flex-center">
        {{ $t("credit.cancel_subscription_title") }}
      </div>
      <div class="contnet">
        {{
          $t("credit.cancel_subscription_tip", {
            date: getLocalizedDate(vipEnd * 1000, $$language()),
          })
        }}
      </div>
      <div class="btn-group flex">
        <Button
          class="flex1 flex-center"
          :renderStyle="{
            '--padding': '0',
            '--width': '100%',
            '--height': '44px',
            '--borderRadius': '50px',
            '--background': 'rgba(255, 255, 255, 0.1)',
            '--fontColor': '#fff',
            '--fontSize': '14px',
            '--fontWeight': '500',
            '--border': 'none',
            '--backgroundHover': 'rgba(255, 255, 255, 0.2)',
            '--fontColorHover': '#fff',
          }"
          @click="handleCancel"
          >{{ $t("create.cancel") }}</Button
        >

        <Button
          class="flex1 flex-center submit-btn"
          :loading="loading"
          :renderStyle="{
            '--padding': '0',
            '--width': '100%',
            '--height': '44px',
            '--borderRadius': '50px',
            '--background': 'rgba(148, 173, 255, 1)',
            '--fontColor': '#000',
            '--fontSize': '14px',
            '--fontWeight': '500',
            '--border': 'none',
            '--backgroundHover': 'rgba(148, 173, 255, 0.8)',
            '--fontColorHover': '#000',
          }"
          @click="handleConfirm"
          >{{ $t("credit.unsubscribe") }}
        </Button>
      </div>
    </div>
  </Dialog>
</template>

<script setup>
import { ref, defineProps, defineEmits } from "vue";
import { getLocalizedDate } from "@/utils/dateTime.js";
import { $$t, $$language } from "@/i18n/i18n.js";
import { feedbackSubscriptionCancel } from "@/api/api/apiCredit.js";
import Button from "@/components/basic/button/Button.vue";
import message from "@/components/functionCallComponent/message/message.js";

const emits = defineEmits(["update:visible", "confirmCancelSuccess"]);
const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  vipEnd: {
    type: Number,
    default: 0,
  },
  list: {
    type: Object,
    default: () => {},
  },
});
const loading = ref(false);

const handleCancel = () => {
  emits("update:visible", false);
};

const handleConfirm = () => {
  loading.value = true;
  feedbackSubscriptionCancel({
    reasons: props.list,
  })
    .then((res) => {
      if (res.code == 200) {
        emits("update:visible", false);
        emits("confirmCancelSuccess");
        message.success({
          position: "top",
          content: $$t("credit.subscription_canceled"),
        });
      } else {
        message.error({
          position: "top",
          content: $$t("credit.subscription_failed"),
        });
      }
    })
    .finally(() => {
      loading.value = false;
    });
};
</script>


<style lang="scss" scoped>
.confirm-cancel-dialog {
  .main {
    padding: 0 40px 40px;
    .title {
      font-size: 18px;
      color: #fff;
    }
    .contnet {
      font-size: 14px;
      color: #fff;
      margin-top: 16px;
    }
    .btn-group {
      margin-top: 28px;
      gap: 12px;
    }
  }
}
</style>

<style lang="scss">
.submit-btn {
  .el-button {
    .el-icon.is-loading {
      background-image: url(@/assets/img/loading-mini-white-3x.png) !important;
    }
  }
}
</style>